import React from 'react';

import './selectInput.style.css';

const SelectInput = ({ id, title, className, value, customPreselectedOption, options, onClick, onChange }) => {
    const handleChange = (event) => {
        onChange({
            text: event.target.id,
            value: event.target.value,
        });
    };

    return (
        <>
            {title && <label htmlFor={id}>{title}</label>}
            <select
                id={id}
                className={`SelectInput ${className}`}
                value={value}
                onChange={handleChange}
                onClick={onClick}
            >
                {customPreselectedOption && (
                    <option value="" key="">
                        {customPreselectedOption}
                    </option>
                )}
                {options.map((option) => (
                    <option value={option.value} key={option.value}>
                        {option.text}
                    </option>
                ))}
            </select>
        </>
    );
};

export default SelectInput;
